import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { createGuideUrl } from './utils/createGuideUrl';
import { guidesData, personasData } from './data';
export const useLaunchStrategyData = () => {
    const { currentShop } = useCurrentShop();
    const persona = currentShop?.persona || 'default';
    const data = persona in personasData ? personasData[persona] : personasData.default;
    const categories = guidesData.map((category) => ({
        ...category,
        guides: category.guides.map((guide) => ({
            title: guide.title,
            url: createGuideUrl(guide.slug, data.guidesParameter),
        })),
    }));
    return {
        recommendation: data.recommendation,
        modal: {
            ...data.modal,
            categories,
        },
    };
};
